import * as React from 'react';

import { Button, Grid, TextField } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-user-filters';

const KeywordForm = ({
  label,
  keyword,
  onChange,
  onSubmit,
}: {
  label: string;
  keyword: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
}) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit(keyword);
        onChange('');
      }}
    >
      <Grid container alignItems="flex-end" spacing={24}>
        <Grid item>
          <TextField
            label={_t('Add keyword phrases to match a #{label}', { label })}
            onChange={(event) => onChange(event.target.value)}
            value={keyword}
            placeholder={_t('Enter a keyword phrase')}
            autoFocus
          />
        </Grid>
        <Grid item>
          <Button variant="secondary" type="submit">
            {_t('Add keyword')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default KeywordForm;
